<ion-item class="btn-profile" (click)="onMyProfile()" button="true" mode="md">
  <ion-label>{{ 'CORE.MENU.MY_PROFILE' | translate }}</ion-label>
</ion-item>
<ion-item
  class="btn-profile"
  (click)="onMail()"
  button="true"
  mode="md"
  *ngIf="this.auth.checkUserIsParticular()"
>
  <ion-label slot="start">{{ 'CORE.MENU.INBOX' | translate }}</ion-label>
  <ion-label slot="end">{{
    (menu.unreadMails$ | async) > 99 ? 99 : (menu.unreadMails$ | async)
  }}</ion-label>
</ion-item>
<ion-item class="btn-profile" (click)="onLogout()" button="true" mode="md">
  <ion-label>{{
    this.auth.checkUserIsParticular()
      ? ('CORE.LOGOUT.CLOSE_SESSION' | translate)
      : ('CORE.LOGOUT.CLOSE_SESSION_BUSINESS' | translate)
  }}</ion-label>
</ion-item>
